import { ListPaymentOrdersQueryVariables, PaymentOrderLienStatusEnum, SortEnum } from '@/types/generated/graphql';

export const CONFIRM_PAYMENT_BADGE_VARIABLES: ListPaymentOrdersQueryVariables = {
  lienStatus: PaymentOrderLienStatusEnum.confirmation_requested,
  limit: 100,
  sort: SortEnum.ASC,
  order: 'createdAt',
};
